<template>
  <div class="columns is-centered">
    <div class="column is-two-thirds">
      <div class="notification is-warning" v-if="isDelinquent">
        Either your trial period has ended or we were unable to process your
        subscription payment. Please update your credit card information in
        order to continue using ShareDocView.
      </div>
      <!-- END notification -->
      <!-- Disable Credit Card Form -->
      <!--
        <ValidationObserver ref="observer" v-slot="{ pristine, passes }">
          <form @submit.prevent="passes(updatePayment)">
            <div class="columns">
              <div class="column">
                <div class="field">
                  <ValidationProvider
                    name="Card Number"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label>Card Number</label>
                    <input
                      type="text"
                      class="input"
                      :class="{ 'is-danger': errors.length }"
                      v-model="card.number"
                      placeholder="0000-0000-0000-0000"
                      pattern="^([0-9]{4}-){3}[0-9]{4}$"
                      v-mask="'####-####-####-####'"
                    />
                    <p class="help is-danger" v-show="errors.length">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-two-thirds">
                <div class="columns">
                  <div class="column is-half">
                    <div class="field">
                      <ValidationProvider
                        name="Expiration Month"
                        rules="required"
                        v-slot="{ errors }"
                      >
                        <label>Expiration Month</label>
                        <input
                          type="text"
                          class="input"
                          :class="{ 'is-danger': errors.length }"
                          v-model="card.expirationMonth"
                          placeholder="05"
                          pattern="^(0[0-9])|(1[0-2])$"
                        />
                        <p class="help is-danger" v-show="errors.length">
                          {{ errors[0] }}
                        </p>
                      </ValidationProvider>
                    </div>
                  </div>
                  <div class="column is-half">
                    <div class="field">
                      <ValidationProvider
                        name="Expiration Year"
                        :rules="
                          'required|numeric|between:' +
                            currentYear +
                            ',' +
                            (currentYear + 7)
                        "
                        v-slot="{ errors }"
                      >
                        <label>Expiration Year</label>
                        <input
                          type="number"
                          class="input"
                          :class="{ 'is-danger': errors.length }"
                          v-model="card.expirationYear"
                          :placeholder="currentYear"
                        />
                        <p class="help is-danger" v-show="errors.length">
                          {{ errors[0] }}
                        </p>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
              </div>
              <div class="column is-one-third">
                <div class="field">
                  <ValidationProvider
                    name="CVC"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label>CVC</label>
                    <input
                      type="text"
                      class="input"
                      :class="{ 'is-danger': errors.length }"
                      v-model="card.cvc"
                      placeholder="123"
                      pattern="^[0-9]{3,4}$"
                    />
                    <p class="help is-danger" v-show="errors.length">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <div class="field">
                  <ValidationProvider
                    name="Full Name"
                    rules="required"
                    v-slot="{ errors }"
                  >
                    <label>Name on Card</label>
                    <input
                      type="text"
                      class="input"
                      :class="{ 'is-danger': errors.length }"
                      v-model="card.name"
                      placeholder="John Doe"
                      pattern="^[A-Za-z\s]+$"
                    />
                    <p class="help is-danger" v-show="errors.length">
                      {{ errors[0] }}
                    </p>
                  </ValidationProvider>
                </div>
              </div>
            </div>
            <div class="columns">
              <div class="column is-one-quarter">
                <div class="field">
                  <input
                    :disabled="pristine || loading"
                    type="submit"
                    value="Save Changes"
                    class="button is-primary"
                  />
                </div>
              </div>
            </div>
          </form>
        </ValidationObserver>
        <div class="is-divider" data-content="or"></div>
      -->
      <!-- END Disabled Credit Card Form -->
      <div class="notification is-info is-light">
        <p>
          <strong>Have a promo code?</strong>
        </p>
        <p class="mb-2">
          <small>
            <em> Redeem your promo codes here. </em>
          </small>
        </p>
        <p>
          Just input the code in the field below and make sure to follow the
          pattern 0000-0000-0000-0000-0000.
        </p>
      </div>
      <ValidationObserver v-slot="{ pristine, passes }">
        <form class="redeem-code" @submit.prevent="passes(redeemCode)">
          <div class="columns">
            <div class="column">
              <div class="field">
                <ValidationProvider
                  name="Promo Code"
                  rules="required"
                  v-slot="{ errors }"
                >
                  <label>Redeem Code</label>
                  <input
                    type="text"
                    class="input"
                    :class="{ 'is-danger': errors.length }"
                    v-model="promo.code"
                    placeholder="0000-0000-0000-0000-0000"
                    :pattern="promoPattern"
                    v-mask="promoMask"
                  />
                  <p class="help is-danger" v-show="errors.length">
                    {{ errors[0] }}
                  </p>
                </ValidationProvider>
              </div>
            </div>
          </div>
          <div class="columns">
            <div class="column is-one-quarter">
              <div class="field">
                <input
                  :disabled="pristine || loading"
                  type="submit"
                  value="Redeem Code"
                  class="button is-primary"
                />
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
      <!-- <div v-if="user.account.subscription.plan.name !== 'Free'">
        <div class="notification has-background-grey-light">
          <p class="has-text-light has-margin-bottom-1">
            You are currently subscribed to the
            <strong>{{ user.account.subscription.plan.name }}</strong> plan
            <small> (possible courtesy upgrade for a trial period). </small>
          </p>
          <p class="has-text-light has-margin-bottom-1">
            <small>
              You may downgrade to a free plan if you prefer (no credit card
              info needed). But remember you will lose access to some of our
              more advanced features.
            </small>
          </p>
          <button
            @click="downgradeToFree()"
            class="button is-small"
            :disabled="user._id !== user.account.owner"
          >
            <span>Downgrade to Free</span>
          </button>
        </div>
      </div> -->
    </div>
  </div>
</template>
<script>
import { ValidationObserver, ValidationProvider } from 'vee-validate';
import { removeHyphens } from '@/utils/general';

const masks = {
  codes: 'NNNN-NNNN-NNNN-NNNN-NNNN',
  coupons: 'NNNNNNNNN'
};

export default {
  name: 'PaymentForm',
  components: {
    ValidationObserver,
    ValidationProvider
  },
  props: ['userData'],
  computed: {
    isDelinquent() {
      return this.$route.query.delinquent;
    },
    promoPattern() {
      const patterns = [
        '([A-Z0-9]{5,9})',
        '(([B-DF-HJ-NP-TV-Z0-9]{4}-){4}[B-DF-HJ-NP-TV-Z0-9]{4})'
      ];
      const pattern = `^${patterns.join('|')}$`;
      return pattern;
    },
    promoMask() {
      const mask = this.promo.code.length > 9 ? masks.codes : masks.coupons;
      return mask;
    }
  },
  data() {
    return {
      currentYear: this.$moment().year(),
      loading: false,
      disable: false,
      card: {
        number: this.$store.state.auth.user.payment
          ? '0000-0000-0000-' + this.$store.state.auth.user.payment.last4
          : '',
        expirationMonth: this.$store.state.auth.user.payment
          ? this.$store.state.auth.user.payment.exp_month
          : '',
        expirationYear: this.$store.state.auth.user.payment
          ? this.$store.state.auth.user.payment.exp_year
          : '',
        cvc: '',
        name: this.$store.state.auth.user.payment
          ? this.$store.state.auth.user.payment.name
          : ''
      },
      promo: {
        code: ''
      },
      user: this.userData || {}
    };
  },
  methods: {
    async redeemCode(event) {
      event && event.preventDefault();
      this.loading = true;
      try {
        const code = removeHyphens(this.promo.code);
        // Prepare post data and set action to current promo code
        const promo = {
          promoCode: code
        };
        // Request to apply promo code
        await this.$axios.post(this.$API.promos, promo);
        this.$notify({
          group: 'alert',
          title: 'Success!',
          text: 'Successfully redeemed your code.',
          type: 'success'
        });
        // Get user data
        this.user = (await this.$axios.get(this.$API.me)).data;
        // Update local storage with user data
        this.$store.commit('auth/setUser', this.user);
        // Trigger an event to notify parent components that the data has been saved successfully.
        this.$emit('updated');
        // Send the user to their original location or the dashboard.
        this.$nextTick(() => {
          this.$router.push({
            path:
              this.$route.query && this.$route.query.from
                ? this.$route.query.from
                : '/dashboard'
          });
        });
      } catch (error) {
        const errorMessage =
          error.response?.data?.message ||
          'This code is not available please verify your code and try again.';
        this.$notify({
          group: 'alert',
          title: 'FAILED!',
          text: errorMessage,
          type: 'error'
        });
      }
      this.loading = false;
    },
    async updatePayment(evt) {
      evt && evt.preventDefault();
      this.loading = true;
      try {
        const card = JSON.parse(JSON.stringify(this.card));
        card.number = removeHyphens(card.number);
        // Do the request.
        await this.$axios.post(this.$API.payment, card);
        // If the request is successful, notify the user.
        this.$notify({
          group: 'alert',
          title: 'Success!',
          text: 'Successfully updated your payment information.',
          type: 'success'
        });
        // Now update the user from the server.
        this.user = (await this.$axios.get(this.$API.me)).data;
        this.$store.commit('auth/setUser', this.user);
        // Clean the form.
        this.resetCardForm();
        // send event indicating that a payment has been added.
        this.$customerly.event('added_payment');
        // Trigger an event to notify parent components that the data has been saved successfully.
        this.$emit('updated');
        // Send the user to their original location or the dashboard.
        this.$nextTick(() => {
          this.$router.push({
            path: this.$route.query ? this.$route.query.from : '/dashboard'
          });
        });
      } catch (err) {
        console.error(err);
        this.$notify({
          group: 'alert',
          title: 'FAILED!',
          text: 'Please check your payment information and try again.',
          type: 'error'
        });
      }
      // Finally clear the loadng status.
      this.loading = false;
    },
    resetCardForm() {
      this.card.cvc = '';
    },
    /**
     * Downgrades the user to a free plan.
     */
    // downgradeToFree() {
    //   this.$axios
    //     .patch(
    //       `${this.$API.subscriptions}/${this.user.account.subscription._id}/plan`,
    //       { plan: 'free' }
    //     )
    //     .then(async response => {
    //       if (response.data.success) {
    //         this.$notify({
    //           group: 'alert',
    //           title: 'Success!',
    //           text: 'Successfully updated your subscription.',
    //           type: 'success'
    //         });
    //         this.user = (await this.$axios.get(this.$API.me)).data;
    //         this.$store.commit('auth/setUser', this.user);
    //         if (this.$route.query && this.$route.query.from) {
    //           this.$router.push({ path: this.$route.query.from });
    //         } else {
    //           this.$router.push({ path: '/dashboard' });
    //         }
    //       }
    //     })
    //     .catch(error => {
    //       console.log('Error:', error);
    //       this.$notify({
    //         group: 'alert',
    //         title: 'FAILED!',
    //         text:
    //           'Something went wrong while processing your request. Please try again later.',
    //         type: 'error'
    //       });
    //     });
    // }
  }
};
</script>
<style lang="scss" scoped>
figure {
  margin-left: auto;
  margin-right: auto;
}
.tabs {
  margin-top: 15px;
}
.redeem-code {
  margin-bottom: 15px;
}
</style>
